import { createAction, createReducer } from "@reduxjs/toolkit";
import { uniqueId } from "../../helpers/form.helper";
import { HELP_CENTER } from "../../types/global.enum";
export const reloadSegments = createAction('reloadSegments');
export const toggleSpinner = createAction<boolean>('APP-TOGGLE-SPINNER');
export const toggleAlert = createAction<any>('APP-TOGGLE-ALERT');
export const closeAlert = createAction('APP-CLOSE-ALERT');
export const reloadLibraries = createAction('reloadLibraries');
export const serGrammaroptions = createAction<any[]>('serGrammaroptions');
export const globalNotification = createAction<string>('globalNotification');
export const loadHelpCenter = createAction<HELP_CENTER>('loadHelp');
export const showHelpDetails = createAction<any>('showHelpDetails');
export const setAppConfig = createAction<any>('setAppConfig');
export const setSuperUiConfig = createAction<any>('setSuperUiConfig');
export const setFolderTreeCollapsed = createAction<boolean>('setFolderTreeCollapsed');
export const triggerProjectTestCasesRefresh = createAction<{projectId: number}>('triggerProjectTestCasesRefresh');

export const appReducer = createReducer(null, (builder) => {
    builder.addCase(serGrammaroptions, (state: any, action) => {

        return {
            ...state,
            grammarOptions: action.payload,
        }
    }).addCase(showHelpDetails, (state: any, action) => {

        return {
            ...state,
            helpKey: action.payload,
        }
    }).addCase(loadHelpCenter, (state: any, action) => {

        return {
            ...state,
            helpCenter: action.payload,
        }
    }).addCase(globalNotification, (state: any, action) => {

        return {
            ...state,
            globalNotification: action.payload,
        }
    }).addCase(toggleSpinner, (state: any, action) => {

        return {
            ...state,
            showSpinner: action.payload,
        }
    }).addCase(toggleAlert, (state: any, action) => {
        let message = action.payload;
        let severity = 'error';
        
        // Check if payload is an object with message and severity
        if (typeof action.payload === 'object' && action.payload !== null) {
            message = action.payload.message || '';
            severity = action.payload.severity || 'error';
        }

        return {
            ...state,
            globalAlert: { show: message ? `${new Date().getTime()}` : '', message, severity },
        }
    }).addCase(closeAlert, (state: any, action) => {
        return {
            ...state,
            globalAlert: { show: '', message: '', severity: 'info' },
        }
    }).addCase(reloadLibraries, (state: any, action) => {

        return {
            ...state,
            reloadLibraries: `${new Date().getTime()}`,
        }
    }).addCase(reloadSegments, (state: any, action) => {

        return {
            ...state,
            reloadSegments: uniqueId(),
        }
    }).addCase(setAppConfig, (state: any, action) => {

        return {
            ...state,
            appConfig: action.payload,
        }
    }).addCase(setSuperUiConfig, (state: any, action) => {

        return {
            ...state,
            superUiConfig: action.payload,
        }
    }).addCase(setFolderTreeCollapsed, (state: any, action) => {

        return {
            ...state,
            folderTreeCollapsed: action.payload,
        }
    }).addCase(triggerProjectTestCasesRefresh, (state: any, action) => {

        return {
            ...state,
            projectTestCasesRefreshTrigger: {
                projectId: action.payload.projectId,
                timestamp: new Date().getTime(),
            },
        }
    })


})
